import { Button } from 'primereact/button'
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import React, { useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { STARTER_API } from '../ApiNames'
import { LoginService } from '../services/LoginService'
import { Toast } from 'primereact/toast'

var imageName = require('./../assets/img/mdcal.png');

export const HospitalRegister = () => {
    const useroptions = [
        { label: 'Doctor', value: 'doctor' },
        { label: 'Patient', value: 'patient' },
    ];
    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');

    const [email, setemail] = useState('');
    const [password, setpassword] = useState('');
    const [hospitalname, setHospitalName] = useState('');
    const [hospitalprefix, setHospitalPrefix] = useState('');

    const [isChecked, setIsChecked] = useState(false);
    const handleCheckboxChange = (e: any) => {
        setIsChecked(e.target.checked);
    };
    const [userData, setUserData] = useState<[]>([]);
    const navigate = useNavigate();
    const toast = useRef<Toast | null>(null);

    const HospitalRegister = async () => {
        if (!firstname || !lastname || !password || !email || !hospitalname|| !hospitalprefix) {
            toast.current?.show({
                severity: 'error',
                detail: 'Please fill in all required fields.',
                life: 3000
            });
            return;
        }
        try {
            const payload = { firstname: firstname, lastname: lastname, email: email, hname: hospitalname, hprefix: hospitalprefix, password: password };
            const apiname = STARTER_API.hospitalregister_API;
            const data = await LoginService.getData(apiname, payload);
            if(data === 'Hospital Registered successfully'){
                if (toast.current) {
                    toast.current.show({ severity: 'success', detail: data });
                }  
            }else{
                if (toast.current) {
                    toast.current.show({ severity: 'info', detail: data });
                }
            }
            setFirstname('');
            setLastname('');
            setHospitalName('');
            setHospitalPrefix('');
            setemail('');
            setpassword('');
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    return (
        <div className="main-body flex justify-content-center align-items-center" style={{ flexDirection: 'column', minHeight: '100vh' }}>
            {/* Logo Section */}
            <div className="logo-container mb-4" style={{ display: 'flex', justifyContent: 'center', minWidth: '220px' }}>
                <img src={imageName} alt="Logo" width="220px" style={{ width: '320px' }} />
            </div>

            {/* Login Box */}
            <div className="surface-card p-4 shadow-2 border-round w-full lg:w-4">
           
                <div className="text-center mb-5">
                    <div className="text-900 text-3x font-medium mb-3">
                        <h2 style={{ color: 'rgb(102, 102, 102)', fontSize: '20px', fontWeight: '400' }}>
                            Hospital SignUp
                        </h2>
                    </div>
                </div>
                <div>
                    <div className="p-inputgroup mb-3">
                        <InputText id="name" type="text" value={firstname} placeholder="Enter First Name" className="w-full" onChange={(e) => setFirstname(e.target.value)}
                        />
                        <span className="p-inputgroup-addon" style={{ backgroundColor: 'transparent' }}>
                            <i className="pi pi-user" style={{ fontSize: '1.2em', color: '#666' }}></i>
                        </span>
                    </div>

                    <div className="p-inputgroup mb-3">
                        <InputText id="name" type="text" placeholder="Enter Last Name" value={lastname} className="w-full" onChange={(e) => setLastname(e.target.value)} />
                        <span className="p-inputgroup-addon" style={{ backgroundColor: 'transparent' }}>
                            <i className="pi pi-user" style={{ fontSize: '1.2em', color: '#666' }}></i>
                        </span>
                    </div>
                    <div className="p-inputgroup mb-3">
                        <InputText id="name" type="text" placeholder="Enter Hospital Name" value={hospitalname} className="w-full" onChange={(e) => setHospitalName(e.target.value)}
                        />
                        <span className="p-inputgroup-addon" style={{ backgroundColor: 'transparent' }}>
                            <i className="pi pi-user" style={{ fontSize: '1.2em', color: '#666' }}></i>
                        </span>
                    </div>

                    <div className="p-inputgroup mb-3">
                        <InputText id="name" type="text" placeholder="Enter Hospital Prefix" value={hospitalprefix} className="w-full" onChange={(e) => setHospitalPrefix(e.target.value)} />
                        <span className="p-inputgroup-addon" style={{ backgroundColor: 'transparent' }}>
                            <i className="pi pi-user" style={{ fontSize: '1.2em', color: '#666' }}></i>
                        </span>
                    </div>



                    <div className="p-inputgroup mb-3">
                        <InputText id="email" type="text" placeholder="Enter Email" className="w-full" value={email} onChange={(e) => setemail(e.target.value)} />
                        <span className="p-inputgroup-addon" style={{ backgroundColor: 'transparent' }}>
                            <i className="pi pi-envelope" style={{ fontSize: '1.2em', color: '#666' }}></i>
                        </span>
                    </div>

                    <div className="p-inputgroup mb-3">
                        <InputText id="password" type="password" placeholder="Enter Password" className="w-full" value={password} onChange={(e) => setpassword(e.target.value)} />
                        <span className="p-inputgroup-addon" style={{ backgroundColor: 'transparent' }}>
                            <i className="pi pi-lock" style={{ fontSize: '1.2em', color: '#666' }}></i>
                        </span>
                    </div>

                    <div className="p-field-checkbox" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <input type="checkbox" id="remember" checked={isChecked} onChange={handleCheckboxChange} style={{ marginRight: '10px' }} />
                            <label htmlFor="terms" className="p-checkbox-label"><span style={{ color: 'rgb(102, 102, 102)', fontWeight: '900', fontFamily: 'Source Sans Pro, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", Segoe UI Symbol', fontSize: '18px' }}>Remember Me</span></label>
                        </div>

                        <Button label="Sign Up" style={{ backgroundColor: 'rgb(0, 105, 217)', marginTop: '20px',color:'#fff' }} icon="pi pi-user"  onClick={HospitalRegister} text raised/>
                    </div>

                    <div style={{ textAlign: 'left', marginTop: '20px' }}>
                        <Link to="/" style={{ textDecoration: 'none', color: 'rgb(0, 86, 179)' }}>I already have a membership</Link>
                    </div>

                </div>
            </div>
            <Toast ref={toast} ></Toast>
        </div>
    )
}
